import {
  ACCESS_TOKEN,
  PRACTICE_ID_HEADER_NAME,
  TOKEN_TYPE,
} from "../../constants/api.constant";

export const apiHeaders = (
  practiceId: string | undefined,
  headers: Headers,
  withJsonContentType = true
): Headers => {
  const accessToken = sessionStorage.getItem(ACCESS_TOKEN);
  const tokenType = sessionStorage.getItem(TOKEN_TYPE);

  if (accessToken && tokenType) {
    headers.set("Authorization", `${tokenType} ${accessToken}`);
  }

  if (practiceId) {
    headers.set(PRACTICE_ID_HEADER_NAME, practiceId);
  }

  // Skipped for multipart/blob endpoints so the browser can set the correct
  // Content-Type (e.g. multipart boundary for FormData uploads). RTK still
  // auto-applies application/json for plain object bodies.
  if (withJsonContentType) {
    headers.set("Content-Type", "application/json; charset=utf-8");
  }
  return headers;
};
